import { ChartColumn } from "lucide-react"
import { Trigger } from "@/components/design-system"
import { useChartSettings } from "@/hooks/useChartSettings"
import { useDesktopPanelStore } from "@/stores/panelStore"

export function IndicatorsTrigger() {
  const { activeIndicatorCount } = useChartSettings()
  const toggleIndicators = useDesktopPanelStore((s) => s.toggleIndicators)
  const indicatorsOpen = useDesktopPanelStore((s) => s.indicatorsOpen)

  return (
    <Trigger
      id="indicators-btn"
      icon={<ChartColumn className="h-3.5 w-3.5" strokeWidth={1.5} />}
      label="Indicators"
      badge={activeIndicatorCount}
      active={indicatorsOpen}
      onClick={toggleIndicators}
    />
  )
}
